module.exports = __webpack_public_path__ + "img/ywjs_03.268de907.png";